import { render, staticRenderFns } from "./SupportSettings.vue?vue&type=template&id=ce09fbf0&scoped=true"
import script from "./SupportSettings.vue?vue&type=script&lang=js"
export * from "./SupportSettings.vue?vue&type=script&lang=js"
import style0 from "./SupportSettings.vue?vue&type=style&index=0&id=ce09fbf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce09fbf0",
  null
  
)

export default component.exports